import React from "react";

import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import FormatItalicIcon from "@mui/icons-material/FormatItalic";
import TextFormatIcon from "@mui/icons-material/TextFormat";
import FormatSizeIcon from "@mui/icons-material/FormatSize";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'blue',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);
class StyleButton extends React.Component {
  constructor() {
    super();
    this.onToggle = e => {
      e.preventDefault();
      this.props.onToggle(this.props.style);
    };
  }
 
  render() {
    let className = "RichEditor-styleButton";
    if (this.props.active) {
      className += " RichEditor-activeButton";
    }
    const { label, font } = this.props;
 
    return (
      <span className={className} onMouseDown={this.onToggle} style={{width:"10px"}}>
        {font || label}
      </span>
    );
  }
}
 
const BLOCK_TYPES = [
  // { label: "H1", style: "header-one" },
  // { label: "H2", style: "header-two" },
  // { label: "H3", style: "header-three" },
  // { label: "H4", style: "header-four" },
  // { label: "H5", style: "header-five" },
  // { label: "H6", style: "header-six" },
  // {label: 'Blockquote', style: 'blockquote'},
  {
    label: "UL",
    style: "unordered-list-item",
    font: <LightTooltip title="Bulleted List"><i className="fa fa-list" style={{fontSize:"16px",color:"#1976D2"}} aria-hidden="true"></i></LightTooltip>
  },
  {
    label: "OL",
    style: "ordered-list-item",
    font: <LightTooltip title="Ordered List"><i className="fa fa-list-ol" style={{fontSize:"16px",color:"#1976D2"}} aria-hidden="true"></i></LightTooltip>
  },
  // {
  //   label: "Code Block",
  //   style: "code-block",
  //   font: <i className="fa fa-file-code-o" aria-hidden="true"></i>
  // }
];

const INLINE_UL_STYLE = [
  {
    label: "UL",
    style: "unordered-list-item",
    font: <FormatListBulletedIcon />
  },
]

const INLINE_OL_STYLE = [
  {
    label: "OL",
    style: "ordered-list-item",
    font: <FormatListNumberedIcon/>
  },
]
 
const BlockStyleControls = props => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();
  return (
    <div className="RichEditor-controls" style={{display:"flex",alignItems:'center',marginTop:'8px'}}>
      {BLOCK_TYPES.map(type => (
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          font={type.font}
        />
      ))}
    </div>
  );
};
 

const ULStyleControls = props => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();
  return (
    <div className="RichEditor-controls" style={{display:"flex",alignItems:'center',marginTop:'8px'}}>
      {INLINE_UL_STYLE.map(type => (
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          font={type.font}
        />
      ))}
    </div>
  );
};

const OLStyleControls = props => {
  const { editorState } = props;
  const selection = editorState.getSelection();
  const blockType = editorState
    .getCurrentContent()
    .getBlockForKey(selection.getStartKey())
    .getType();
  return (
    <div className="RichEditor-controls" style={{display:"flex",alignItems:'center',marginTop:'8px'}}>
      {INLINE_OL_STYLE.map(type => (
        <StyleButton
          key={type.label}
          active={type.style === blockType}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          font={type.font}
        />
      ))}
    </div>
  );
};
 
let INLINE_STYLES = [
  {
    label: "Bold",
    style: "BOLD",
    font: <LightTooltip title="Bold"><i className="fa fa-bold fa-sm" style={{fontSize:"14px",color:"#1976D2" , marginLeft:"0px",paddingLeft:"0px"}} aria-hidden="true"></i></LightTooltip>

  },
  {
    label: "Italic",
    style: "ITALIC",
    font: <LightTooltip title="Italic"><i className="fa fa-italic" style={{fontSize:"14px",color:"#1976D2"}} aria-hidden="true"></i></LightTooltip>
  },
  {
    label: "Underline",
    style: "UNDERLINE",
    font: <LightTooltip title="Underline"><i className="fa fa-underline" style={{fontSize:"14px",color:"#1976D2"}} aria-hidden="true"></i></LightTooltip>
  },
  {
    label: "Monospace",
    style: "CODE",
    font: <LightTooltip title="Code"><i className="fa fa-code" style={{fontSize:"14px",color:"#1976D2"}} aria-hidden="true"></i></LightTooltip>
  },
  // {
  //   label: "Link",
  //   style: "ANCHOR",
  //   font: <i title="Link" id="anchorFa" className="fa fa-link" aria-hidden="true"></i>
  // },
  // {
  //   label: "subscript",
  //   style: "SUBSCRIPT",
  //   children: (
  //     <div className="SubButton-button ToolbarButton-button">
  //       x<sub>2</sub>
  //     </div>
  //   )
  // },
  {
    label: "superscript",
    style: "SUPERSCRIPT",
    children: (
      <div className="SupButton-button ToolbarButton-button">
        x<sup>4</sup>
      </div>
    ),
    font: <LightTooltip title="Superscript"><i  className="fa fa-superscript" style={{fontSize:"14px",color:"#1976D2"}} aria-hidden="true"></i></LightTooltip>
  }
];
 


let INLINE_BOLD_STYLE = [
  {
    label: "Bold",
    style: "BOLD",
    font: <FormatBoldIcon />
  }
];
 
let INLINE_ITALIC_STYLE = [
  {
    label: "Italic",
    style: "ITALIC",
    font: <FormatItalicIcon />
  }
];

let INLINE_UNDERLINE_STYLE =[
  {
    label: "Underline",
    style: "UNDERLINE",
    font: <TextFormatIcon />
  },
]
let INLINE_SUPERSCRIPT_STYLE =[
{
  label: "superscript",
  style: "SUPERSCRIPT",
  children: (
    <div className="SupButton-button ToolbarButton-button">
      x<sup>4</sup>
    </div>
  ),
  font: <FormatSizeIcon />
}]
const InlineStyleControls = props => {
  let currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div className="RichEditor-controls" style={{display:"flex",alignItems:'center',marginTop:'5px'}}>
      {INLINE_STYLES.map(type => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          font={type.font}
        />
      ))}
     
    </div>
  );
};

const InlineBold = props => {
  let currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <span>
      {INLINE_BOLD_STYLE.map(type => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          // label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          font={type.font}
        />
      ))}
 
    </span>
  );
};
const InlineItalic = props => {
  let currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <span >
      {INLINE_ITALIC_STYLE.map(type => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          // label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          font={type.font}
        />
      ))}
 
    </span>
  );
};
const InlineUnderline = props => {
  let currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <span>
      {INLINE_UNDERLINE_STYLE.map(type => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          // label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          font={type.font}
        />
      ))}
 
    </span>
  );
};

const InlineSuperscript = props => {
  let currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <span  >
      {INLINE_SUPERSCRIPT_STYLE.map(type => (
        <StyleButton
          key={type.label}
          active={currentStyle.has(type.style)}
          // label={type.label}
          onToggle={props.onToggle}
          style={type.style}
          font={type.font}
        />
      ))}
 
    </span>
  );
};


 
export {ULStyleControls,OLStyleControls, InlineStyleControls, BlockStyleControls ,InlineBold,InlineItalic,InlineUnderline,InlineSuperscript};
 